export const CUSTOM_FILEPICKER = {
	label: 'Select Icon',
	browse_message: 'Browse Image/Icon',
	image_selected: 'Image Selected',
	invalid_file_message: 'Please upload .jpg, .jpeg, .png files only',
	upload_default_error_message: 'Error occured while uploading file.',
	size_invalidation: "Upload file size can't exceed 2MB.",
	size: 2000001, // 2MB in bytes
};
